/**
 * KAN-871: бейдж личного Telegram-аккаунта менеджера в строке экрана
 * Telegram-аккаунтов кабинета: "Личный: ФИО". У аккаунтов компании ничего.
 */
import { isPersonalTelegramAccount } from '@/lib/telegramAccountActions';
import type { TelegramAccount } from '@/types/telegramAccount';

export function PersonalAccountBadge({ account }: { account: TelegramAccount }): JSX.Element | null {
  if (!isPersonalTelegramAccount(account)) return null;
  const owner = (account.personal_manager_name ?? '').trim() || 'менеджер';
  return (
    <span
      className="mt-1 w-fit rounded bg-violet-100 px-1.5 py-0.5 text-xs font-normal text-violet-700"
      data-testid={`personal-badge-${account.operator_id}-${account.account_id}`}
      title="Личный аккаунт менеджера: рассылки с него нет, писать может только сам менеджер"
    >
      Личный: {owner}
    </span>
  );
}
